// ----------------------------- REACT LIBRARIES ---------------------------
export {  getSession, Image, Link, React, SidebarAction, Tooltip, useState, useEffect, useQueryClient, 
         useRouter, useSWR, REDIRECT, useNavbarStatus, useUser, COMMON, useTranslation} from '@/imports-files/common/common';
// ----------------------------- REACT LIBRARIES ---------------------------

// ----------------------------- CONSTANTS ---------------------------
export {  SIDEBAR_OPTIONS, ADMIN_SIDEBAR_OPTIONS, AGENCY_SIDEBAR_OPTIONS} from '@/constants/components/sidebar';
// ----------------------------- CONSTANTS ---------------------------


// ----------------------------- ACTIONS ---------------------------
export {logoutUser} from '@/actions/common/authentication/logout';
export { setSidebarIcons } from '@/actions/common/sidebar';
export { MobileSidebar } from '@/actions/components/mobile-sidebar';
export { selectSidebarOptionFromUrl } from '@/actions/common/sidebar-values';
export { SubsidebarAction } from '@/actions/components/subsidebar';
// ----------------------------- ACTIONS ---------------------------


// ----------------------------- COMPONENTS ---------------------------
export { SubSidebarListItem, SubSidebarListItemWithSubMenu } from '@/components/subsidebar-list-item.js';
export {SubSidebar} from '@/components/subsidebar';
export { MobileSubSidebarListItem, MobileSubSidebarListItemWithSubMenu } from '@/components/subsidebar-list-item';
// ----------------------------- COMPONENTS ---------------------------



// ---------------------------- IMAGES ----------------------------
export { default as CandidateIcon } from "public/images/components/sidebar/candidate-icon.svg";
export { default as DashboardIcon } from "public/images/components/sidebar/dashboard-icon.svg";
export { default as DocumentIcon } from "public/images/components/sidebar/document-icon.svg";
export { default as JobIcon } from "public/images/components/sidebar/job-icon.svg";
export { default as ReportIcon } from "public/images/components/sidebar/report-icon.svg";
export { default as SettingsIcon } from "public/images/components/sidebar/setting-icon.svg";
export { default as ActivityIcon } from "public/images/components/sidebar/activity.svg";
export { default as BackToHome } from "public/images/components/sidebar/backToHome.svg";
export { default as CommunicationIcon } from "public/images/components/sidebar/communication.svg";
export { default as ClientIcon } from "public/images/components/sidebar/clients.svg";
export { default as UsersIcon } from "public/images/components/sidebar/users-icon.svg";
export { default as CompanyImage } from "public/images/components/sidebar/company-logo.png";
export { default as DotsImage } from "public/images/components/sidebar/dots.png";
export { default as ArrowLeft } from "public/icons/arrowleft.svg";
// ---------------------------- IMAGES ----------------------------



// ----------------------------- STYLESHEET ---------------------------
export {default as Style } from '@/styles/components/sidebar/_index.module.scss';
// ----------------------------- STYLESHEET ---------------------------
